import {Injectable} from '@angular/core';
import {Headers, Http} from '@angular/http';

import 'rxjs/add/operator/toPromise';

@Injectable()
export class TransactionsService {
    private headers = new Headers({'Content-Type': 'application/json'});

    private api_url_add_to_pannier = './api/server.php?cmd=PURCHASE_ORDER_SESSION';
    private api_url_remove_form_pannier = './api/server.php?cmd=DELETE_PURCAHSE_ORDER_SESSION';
    private api_url_modify_this_article_session_purchase = "./api/server.php?cmd=MODIFY_PUCHASE_ORDER";
    private api_url_validate_modification_article_session_puchase = './api/server.php?cmd=VALIDATE_SESSION_MODIFICATION_PURCHASE';
    private api_url_load_session_purchase = './api/server.php?cmd=GET_PURCHASE_SESSION';
    private api_url_validate_purchase_session = './api/server.php?cmd=VALIDATE_PURCHASE_SESSION';
    private api_url_get_validate_purchase_list = './api/server.php?cmd=GET_VALIDATE_PURCHASE_LIST';
    private api_url_get_not_validate_purchase_list = './api/server.php?cmd=GET_NOT_VALIDATE_PURCHASE_LIST';
    private api_url_get_refused_purchase_list = './api/server.php?cmd=GET_REFUSED_PURCHASE_LIST';
    private api_url_get_purchase_details = './api/server.php?cmd=GET_PURCHASE_DETAILS';
    private api_url_get_os_details = './api/server.php?cmd=GET_OS_ORDER_DETAILS';
    private api_url_delete_purchase_details_of_index = './api/server.php?cmd=DELETE_PURCAHSE_DETAIL_SESSION';
    private api_url_modify_this_article_session_purchase_detail = './api/server.php?cmd=MODIFY_PURCHASE_DETAIL_SESSION';
    private api_url_modify_this_article_session_purchase_detail_bcf = './api/server.php?cmd=MODIFY_PURCHASE_DETAIL_SESSION_BCF';
    private api_url_modify_this_article_session_purchase_detail_os = './api/server.php?cmd=MODIFY_OS_DETAIL_SESSION_BCF';
    private api_url_validate_modification_article_session_puchase_detail = './api/server.php?cmd=VALIDATE_SESSION_MODIFICATION_PURCHASE_DETAIL';
    private api_url_validate_modification_article_session_puchase_detail_bfc = './api/server.php?cmd=VALIDATE_SESSION_MODIFICATION_PURCHASE_DETAIL_BCF';
    private api_url_validate_modification_article_session_puchase_detail_os = './api/server.php?cmd=VALIDATE_SESSION_MODIFICATION_PURCHASE_DETAIL_OS';
    private api_url_validate_purchase_session_detail = './api/server.php?cmd=VALIDATE_PURCHASE_SESSION_DETAIL';
    private api_url_validate_purchase_details = './api/server.php?cmd=VALIDATE_PURCHASE';
    private api_url_cancel_purchase_details = './api/server.php?cmd=CANCEL_PURCHASE';
    private api_url_clean_purchase_details = './api/server.php?cmd=CLEAN_PURCHASE_SESSION';

    //VENTE
    private api_url_add_to_pannier_out_of_ware = './api/server.php?cmd=OUT_OF_WARE_ORDER_SESSION';
    private api_url_remove_form_pannier_out_of_ware = './api/server.php?cmd=DELETE_OUT_OF_WARE_ORDER_SESSION';
    private api_url_modify_this_article_session_out_of_ware = "./api/server.php?cmd=MODIFY_OUT_OF_WARE_ORDER_SESSION";
    private api_url_validate_modification_article_session_out_of_ware = './api/server.php?cmd=VALIDATE_OUT_OF_WARE_ORDER_SESSION';
    private api_url_load_session_out_of_ware = './api/server.php?cmd=GET_OUT_OF_WARE_SESSION';
    private api_url_validate_out_of_ware_session = './api/server.php?cmd=VALIDATE_OUT_OF_WARE_SESSION';
    private api_url_get_validate_out_of_ware_list = './api/server.php?cmd=GET_VALIDATE_OUT_OF_WARE_LIST';
    private api_url_get_out_of_ware_details = './api/server.php?cmd=GET_OUT_OF_WARE_DETAILS';
    private api_url_delete_out_of_ware_details_of_index = './api/server.php?cmd=DELETE_OUT_OF_WARE_DETAIL_SESSION';
    private api_url_validate_out_of_ware_details = './api/server.php?cmd=VALIDATE_OUT_OF_WARE';


    private api_url_get_sent_purchase_order_list = './api/server.php?cmd=GET_SENT_PURCHASE_ORDER';
    private api_url_get_not_sent_purchase_order_list = './api/server.php?cmd=GET_NOT_SENT_PURCHASE_ORDER';
    private api_url_get_purchase_order_detail = './api/server.php?cmd=GET_PURCHASE_ORDER_DETAILS';
    private api_url_validate_order = './api/server.php?cmd=VALIDATE_PURCHASE_ORDER';
    private api_url_validate_bcf = './api/server.php?cmd=VALIDATE_BCF';
    private api_url_appro_from_dashbord = './api/server.php?cmd=PURCHASE_ORDER_SESSION_FROM_DASHBOARD';
    private api_url_load_session_purchase_details = './api/server.php?cmd=GET_PURCHASE_ORDER_DETAILS_BCF';
    private api_url_load_session_os_details = './api/server.php?cmd=GET_OS_ORDER_DETAILS_BCF';
    private api_url_cancel_purchase_order = './api/server.php?cmd=CANCEL_PURCHASE_ORDER';
    private api_url_movement_history_list = './api/server.php?cmd=GET_MOVEMENT_HISTORY_DESC';
    private api_url_get_purchase_details_session = './api/server.php?cmd=GET_PURCHASE_SESSION_DETAIL';
    private api_url_add_article_infos_bcf = './api/server.php?cmd=ARTICLES_INFOS_PURCHASE_DETAIL_BCF';
    private api_url_add_article_infos_os = './api/server.php?cmd=ARTICLES_INFOS_OS_DETAIL';
    private api_url_refuse_purchase = './api/server.php?cmd=REFUSE_PURCHASE';
    private api_url_delete_purchase = './api/server.php?cmd=DELETE_PURCHASE';

    private api_url_update_date_purchase = './api/server.php?cmd=PURCHASE_ORDER_SESSION_DATE';
    private api_url_get_remains_to_deliver_supplier = './api/server.php?cmd=REMAINS_TO_DELIVER_SUPPLIER';
    private api_url_get_orders_details = './api/server.php?cmd=GET_ORDERS_DETAILS';
    private api_url_get_return_from_supplier = './api/server.php?cmd=RETURN_FROM_SUPPLIER';
    private api_url_get_sent_release_order_list = './api/server.php?cmd=GET_SENT_RELEASE_ORDER';
    private api_url_get_dashbaord_infos = './api/server.php?cmd=DASHBOARD_INFOS';
    
    private api_url_search_remains_to_deliver_supplier = './api/server.php?cmd=REMAINS_TO_DELIVER_SUPPLIER';
    private api_url_search_return_from_supplier = './api/server.php?cmd=RETURN_FROM_SUPPLIER';

    constructor(private http: Http) {}

    CancelPurchaseOrder(): Promise<Object> {
        return this.http.get(this.api_url_cancel_purchase_order)
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    GetMovementHistoryList(): Promise<Object> {
        return this.http.get(this.api_url_movement_history_list)
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    updateDatePurchase(date: any): Promise<Object> {
        return this.http.get(this.api_url_update_date_purchase
            + '&date=' + date
        )
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    AddtoPannier(date: any, prod: any): Promise<Object> {
        return this.http.get(this.api_url_add_to_pannier
            + '&date=' + date
            + '&name=' + prod.name
            + '&stocks=' + prod.stock
            + '&id_article=' + prod.id_article
            + '&quantity=' + prod.quantity
        )
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    ApprFromDashboard(checked_list: string): Promise<Object> {
        return this.http.get(this.api_url_appro_from_dashbord + '&checked_list=' + checked_list)
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    AddtoPannierOutofWare(prod: any): Promise<Object> {
        return this.http.get(this.api_url_add_to_pannier_out_of_ware
            + '&name=' + prod.name
            + '&stocks=' + prod.available_stock
            + '&id_article=' + prod.id_article)
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    RemoveFromPannier(id_article: number): Promise<Object> {
        return this.http.get(this.api_url_remove_form_pannier + '&id_article=' + id_article)
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    RemoveFromPannierOutOfWare(id_article: number): Promise<Object> {
        return this.http.get(this.api_url_remove_form_pannier_out_of_ware + '&id_article=' + id_article)
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    RemoveFromPannierPurchaseDetail(id_article: number): Promise<Object> {
        return this.http.get(this.api_url_delete_purchase_details_of_index + '&id_article=' + id_article)
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    RemoveFromPannierOutOfWareDetail(id_article: number): Promise<Object> {
        return this.http.get(this.api_url_delete_out_of_ware_details_of_index + '&id_article=' + id_article)
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    EditArticleSessionPurchase(id_article: number): Promise<Object> {
        return this.http.get(this.api_url_modify_this_article_session_purchase + '&id_article=' + id_article)
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    EditArticleSessionOutOfWare(id_article: number): Promise<Object> {
        return this.http.get(this.api_url_modify_this_article_session_out_of_ware + '&id_article=' + id_article)
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    EditArticleSessionPurchaseDetail(id_article: number): Promise<Object> {
        return this.http.get(this.api_url_modify_this_article_session_purchase_detail + '&id_article=' + id_article)
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    EditArticleSessionPurchaseDetailBcf(id_article: number, checked: any): Promise<Object> {
        return this.http.get(this.api_url_modify_this_article_session_purchase_detail_bcf + '&id_article=' + id_article + '&checked=' + checked)
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    EditArticleSessionOSDetailBcf(id_article: number, checked: any): Promise<Object> {
        return this.http.get(this.api_url_modify_this_article_session_purchase_detail_os + '&id_article=' + id_article + '&checked=' + checked)
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    ValidateEditArticleSessionPurchase(date: any, date_line: any, prod: any, selected_supplier_string: string): Promise<Object> {
        return this.http.get(this.api_url_validate_modification_article_session_puchase
            + '&date=' + date
            + '&date_line=' + date_line
            + '&id_article=' + prod.id_article
            + '&quantity=' + prod.quantity
            + '&current_supplier=' + selected_supplier_string
        )
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    ValidateEditArticleSessionOutOfWare(prod: any): Promise<Object> {

        return this.http.get(this.api_url_validate_modification_article_session_out_of_ware + '&id_article=' + prod.id_article + '&quantity=' + prod.quantity)
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    ValidateEditArticleSessionPurchaseDetail(prod: any, date_line: any, current_supplier: string): Promise<Object> {
        return this.http.get(this.api_url_validate_modification_article_session_puchase_detail
            + '&id_article=' + prod.id_article
            + '&quantity=' + prod.quantity
            + '&current_supplier=' + current_supplier
            + '&date_line=' + date_line
        )
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    ValidateEditArticleSessionPurchaseDetailBcf(prod: any): Promise<Object> {

        return this.http.get(this.api_url_validate_modification_article_session_puchase_detail_bfc + '&id_article=' + prod.id_article + '&quantity=' + prod.qte_received + '&remark=' + prod.remark)
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    ValidateEditArticleSessionOSDetail(prod: any): Promise<Object> {
        return this.http.get(this.api_url_validate_modification_article_session_puchase_detail_os
            + '&id_article=' + prod.id_article
            + '&quantity=' + prod.qte_received
            + '&remark=' + prod.remark
            + '&id_article_location=' + prod.id_article_location
        )
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    LoadSessionPurchase(): Promise<Object> {
        return this.http.get(this.api_url_load_session_purchase)
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    LoadSessionPurchaseDetail(): Promise<Object> {
        return this.http.get(this.api_url_get_purchase_details_session)
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }



    LoadSessionOutOfWare(): Promise<Object> {
        return this.http.get(this.api_url_load_session_out_of_ware)
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    ValidatePannier(name: string, remark: string, reference: string, date: any): Promise<Object> {
        return this.http.get(this.api_url_validate_purchase_session
            + '&transaction_name=' + name
            + '&remark=' + remark
            + '&reference=' + reference
            + '&date=' + date
        )
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    ValidatePannierOutOfWare(name: string, remark: string): Promise<Object> {
        return this.http.get(this.api_url_validate_out_of_ware_session + '&transaction_name=' + name + '&remark=' + remark)
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    ValidatePannierPurchaseDetails(id_transaction_detail: number): Promise<Object> {
        return this.http.get(this.api_url_validate_purchase_details + '&id_transaction_detail=' + id_transaction_detail)
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }


    CancelPannierPurchaseDetail(): Promise<Object> {
        return this.http.get(this.api_url_cancel_purchase_details)
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    CleanPannierPurchaseDetail(): Promise<Object> {
        return this.http.get(this.api_url_clean_purchase_details)
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    ValidatePannierOutOfWareDetails(id_purchase_order: number, name: string, date: string): Promise<Object> {
        return this.http.get(this.api_url_validate_out_of_ware_details
            + '&id_purchase_order=' + id_purchase_order
            + '&name=' + name + '&date=' + date
        )
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    ValidateBcf(id_purchase_order: number, name: string, date: string): Promise<Object> {
        return this.http.get(this.api_url_validate_bcf
            + '&id_purchase_order=' + id_purchase_order
            + '&name=' + name
            + '&date=' + date)
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }


    RegisterPannierPurchaseDetail(name: string, remark: string, id_transaction_detail: number): Promise<Object> {
        return this.http.get(this.api_url_validate_purchase_session_detail + '&transaction_name=' + name + '&remark=' + remark + '&id_transaction_detail=' + id_transaction_detail)
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    GetValidatePurchaseList(): Promise<Object> {
        return this.http.get(this.api_url_get_validate_purchase_list)
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    GetValidateOutOfWareList(): Promise<Object> {
        return this.http.get(this.api_url_get_validate_out_of_ware_list)
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    GetDashboardInfos(): Promise<Object> {
        return this.http.get(this.api_url_get_dashbaord_infos)
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    GetNotValidatePurchaseList(): Promise<Object> {
        return this.http.get(this.api_url_get_not_validate_purchase_list)
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    getRefusedPurchaseList(): Promise<Object> {
        return this.http.get(this.api_url_get_refused_purchase_list)
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    GetSentPurchaseOrder(): Promise<Object> {
        return this.http.get(this.api_url_get_sent_purchase_order_list)
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    GetSentReleaseOrder(): Promise<Object> {
        return this.http.get(this.api_url_get_sent_release_order_list)
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }



    GetRemainsToDeliverSupplier(): Promise<Object> {
        return this.http.get(this.api_url_get_remains_to_deliver_supplier)
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    GetRetournFromSuppliers(): Promise<Object> {
        return this.http.get(this.api_url_get_return_from_supplier)
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    GetPurchaseOrdersDetails(id_purchase_order: any): Promise<Object> {
        //console.log(id_purchase_order);
        return this.http.get(this.api_url_get_orders_details + '&id_purchase_order=' + id_purchase_order)
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    GetSentPurchaseOrderDetails(): Promise<Object> {
        return this.http.get(this.api_url_load_session_purchase_details)
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    GetSentOSOrderDetails(): Promise<Object> {
        return this.http.get(this.api_url_load_session_os_details)
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    GetNotSentPurchaseOrder(): Promise<Object> {
        return this.http.get(this.api_url_get_not_sent_purchase_order_list)
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }


    GetPurchaseDetails(id_transaction_detail: number): Promise<Object> {
        return this.http.get(this.api_url_get_purchase_details + '&id_transaction_detail=' + id_transaction_detail)
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    GetPurchaseDetailsSession(id_transaction_detail: number): Promise<Object> {
        return this.http.get(this.api_url_get_purchase_details_session + '&id_transaction_detail=' + id_transaction_detail)
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    GetOsDetails(id_transaction_detail: number): Promise<Object> {
        return this.http.get(this.api_url_get_os_details + '&id_transaction_detail=' + id_transaction_detail)
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    GetOutOfWareDetails(id_transaction_detail: number): Promise<Object> {
        return this.http.get(this.api_url_get_out_of_ware_details + '&id_transaction_detail=' + id_transaction_detail)
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    GetPurchaseOrderDetails(id_purchase_order: number): Promise<Object> {
        return this.http.get(this.api_url_get_purchase_order_detail + '&id_purchase_order=' + id_purchase_order)
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    ValidateOrder(id_purchase_order: number, selectedValue: string): Promise<Object> {
        return this.http.get(this.api_url_validate_order + '&id_purchase_order=' + id_purchase_order + '&value=' + selectedValue)
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    AddArticleInfos(global_remark: string, id_purchase_order: any, action: any): Promise<Object> {
        //console.log('action:' + action);
        return this.http.get(this.api_url_add_article_infos_bcf + '&id_purchase_order=' + id_purchase_order + '&action=' + action + '&remark=' + global_remark)
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    AddArticleInfosOs(global_remark: string, id_purchase_order: any, action: any): Promise<Object> {
        return this.http.get(this.api_url_add_article_infos_os
            + '&id_purchase_order=' + id_purchase_order
            + '&action=' + action
            + '&remark=' + global_remark
        )
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    RefusePurchasing(id_transaction_detail: number): Promise<Object> {
        return this.http.get(this.api_url_refuse_purchase + '&id_transaction_detail=' + id_transaction_detail)
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    DeletePurchasing(id_transaction_detail: number): Promise<Object> {
        return this.http.get(this.api_url_delete_purchase + '&id_transaction_detail=' + id_transaction_detail)
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }
    
    SearchRemainsToDeliverSupplier(ref:any, bcf: any): Promise<Object> {
        return this.http.get(this.api_url_search_remains_to_deliver_supplier+ '&reference=' + ref + '&bcf=' + bcf)
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }
    
    SearchreturnFromSupplier(ref:any, bcf: any): Promise<Object> {
        return this.http.get(this.api_url_search_return_from_supplier+ '&reference=' + ref + '&bcf=' + bcf)
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    }


}


// WEBPACK FOOTER //
// ./src/app/transactions.service.ts